import { useCallback, useEffect, useMemo, useState } from "react";

interface ReturnType {
  windowSize: { height: number; width: number };
  isMobile: boolean;
  breakpoint:
    | "mobile"
    | "tablet_vertical"
    | "tablet_horizontal"
    | "laptop"
    | "desk";
}

const useWindowSize = (): ReturnType => {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });

  const [isMobile, setIsMobile] = useState<boolean>(false);

  const handleResize = useCallback(() => {
    if (typeof window !== "undefined") {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });

      if (
        navigator.userAgent.includes("Mobile") ||
        navigator.userAgent.includes("Tablet")
      ) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);

      handleResize();
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, [handleResize]);

  const breakpoint = useMemo(() => {
    switch (true) {
      case windowSize.width >= 768 && windowSize.width < 1024:
        return "tablet_vertical";
      case windowSize.width >= 1024 && windowSize.width < 1110:
        return "tablet_horizontal";
      case windowSize.width >= 1110 && windowSize.width < 1200:
        return "laptop";
      case windowSize.width >= 1200:
        return "desk";
      default:
        return "mobile";
    }
  }, [windowSize.width]);

  return {
    windowSize,
    breakpoint,
    isMobile,
  };
};

export default useWindowSize;
